import { lazy, Suspense } from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import WelcomeName from "./WelcomeName";
import Hidden from "@mui/material/Hidden";
import AppBar from "@mui/material/AppBar";

const Toolbar = lazy(() => import("@mui/material/Toolbar"));
const SignInSignOutButton = lazy(() => import("./SignInSignOutButton"));

const NavBar = (): JSX.Element | null => {
  const isAuthenticated = useIsAuthenticated();
  if (!isAuthenticated) {
    return null;
  }

  return (
    <Suspense fallback="">
      <AppBar position="static" color="inherit">
        <Toolbar>
          <div style={{flexGrow: 1}}>
            <img src="/logo_small.jpg" alt="logo" />
          </div>
          <Hidden only="xs">
            <WelcomeName />
          </Hidden>
          <SignInSignOutButton />
          
        </Toolbar>
      </AppBar>
    </Suspense>
  );
};

export default NavBar;
